import React from 'react';
import { AvailableLanguages } from './available-languages';
import { SearchList } from '../../view/search-list';
import { Props } from './types';
import { fetchAdhocList, fetchAdhocTabs } from '../../view/search-list/queries';
import { MediaItem } from '../../view/search-list/types';

export const RocheMediaReleasesInvestorUpdatesAdhoc = ({ slot }: Props): JSX.Element => (
  <SearchList
    slot={slot}
    tabName='year'
    pageName='page'
    queryName='query'
    fetchTabs={fetchAdhocTabs}
    fetchList={fetchAdhocList}
  >
    {({ items }) => (
      <>
        {items &&
          items.map((item: MediaItem, index) => {
            const availableLanguages = Object.keys(item.Title || {});
            return (
              <roche-teaser
                key={`${item.Slug}-${index}`}
                layout='teaser-variant-c-without-image'
                teaser-title={item.localisedTitle}
                teaser-overline={item.formattedReleaseDate}
                teaser-url={item.link}
              >
                <AvailableLanguages slot='overline' languages={availableLanguages} slug={`${item.path}/${item.Slug}`} />
              </roche-teaser>
            );
          })}
      </>
    )}
  </SearchList>
);
